import React, { useCallback, useState } from 'react'
import clsx from 'clsx'
import { bindActionCreators, Dispatch } from 'redux'
import { connect } from 'react-redux'
import Grid from '@mui/material/Grid'
import Button from 'components/Button'
import Typography from 'components/Typography'
import { useBreakpoint } from 'utils/Hooks'
import Dialog from 'components/Dialog'
import Snackbar from 'components/Snackbar'
import { dialogSelectors, DialogNames, dialogActions } from 'duck/DialogDuck'
import { RootState, RootActionType } from 'duck'
import stylesGlobal from 'stylesGlobal.module.scss'
import { apiActions, apiSelectors } from 'duck/ApiDuck'

const mapStateToProps = (state: RootState) => ({
  openedMineProject: apiSelectors.openedMineProject(state),
  activeDialog: dialogSelectors.activeDialog(state),
  dialogDatum: dialogSelectors.dialogDatum[DialogNames.PROJECT_CONFIRMATION](state)
})

const mapDispatchToProps = (dispatch: Dispatch<RootActionType>) =>
  bindActionCreators(
    {
      updateProject: apiActions.mineProject.updateProject,
      closeDialog: dialogActions.closeDialog
    },
    dispatch
  )

type DialogShareUrlProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

const DialogShareUrl: React.FC<DialogShareUrlProps> = props => {
  const { activeDialog, dialogDatum, openedMineProject, updateProject, closeDialog } = props

  const { isSmallscreenAbove } = useBreakpoint()
  const openedMineProjectId = openedMineProject?.id ?? 0
  const confirmType = dialogDatum?.confirmType
  const is_featured = openedMineProject?.is_featured

  const title =
    confirmType === 'hide_project'
      ? 'Hide Project?'
      : is_featured
      ? 'Remove Feature Project'
      : 'Feature Project?'

  const [openSnackbarCopy, setOpenSnackbarCopy] = useState(false)
  const open = activeDialog === DialogNames.PROJECT_CONFIRMATION

  const onClickYes = useCallback(() => {
    if (confirmType === 'hide_project') {
      updateProject({
        id: openedMineProjectId,
        is_featured: !is_featured
      })
    } else {
      updateProject({
        id: openedMineProjectId,
        is_featured: !is_featured
      })
    }
    closeDialog()
  }, [closeDialog, confirmType, is_featured, openedMineProjectId, updateProject])

  const onClickClose = useCallback(() => closeDialog(), [closeDialog])

  return (
    <>
      <Dialog
        maxWidth="xs"
        open={open}
        onClose={onClickClose}
        onBackdropClick={onClickClose}
        fullWidth
      >
        <div
          className={clsx(
            stylesGlobal.PaddingTop12,
            stylesGlobal.PaddingBottom64,
            stylesGlobal.PaddingX60
          )}
        >
          <Typography
            className={stylesGlobal.MarginBottom16}
            variant="h5"
            align="center"
            fontWeight="bold"
          >
            {title}
          </Typography>

          <Grid container justifyContent={'space-evenly'}>
            <Grid xs={12} sm="auto" item>
              <Button
                className={!isSmallscreenAbove ? stylesGlobal.BorderRoundedTNone : undefined}
                color="secondary"
                variant="contained"
                fullWidth={!isSmallscreenAbove}
                onClick={onClickYes}
              >
                Yes
              </Button>
            </Grid>

            <Grid xs={12} sm="auto" item>
              <Button
                className={!isSmallscreenAbove ? stylesGlobal.BorderRoundedTNone : undefined}
                color="secondary"
                variant="contained"
                fullWidth={!isSmallscreenAbove}
                onClick={() => closeDialog()}
              >
                No
              </Button>
            </Grid>
          </Grid>
        </div>
      </Dialog>

      <Snackbar
        open={openSnackbarCopy}
        message="Copied"
        onClose={() => {
          setOpenSnackbarCopy(false)
        }}
      />
    </>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogShareUrl)
